import OrganisationIndexCategoryMapper from "../../organisations/service/OrganisationIndexCategoryMapper";
import DocumentType from "../model/DocumentType";
import { formatBooleanValue } from "../../util";
import VisibilityLevelMapper from "./VisibilityLevelMapper";

const DocumentTypeMapper = (item: any) => {
  let documentType = DocumentType(item);
  documentType.valid = formatBooleanValue(item.valid);
  documentType.organisationIndexCategories = (
    item.organisationIndexCategories || []
  ).map((elem) => OrganisationIndexCategoryMapper(elem));
  documentType.visibilityLevels = (item.visibilityLevels || []).map((elem) =>
    VisibilityLevelMapper(elem)
  );
  return documentType;
};

export default DocumentTypeMapper;
